<template>
	<div id="app">
		<div class="header">
			<!-- 头部搜索条件 -->
			<genjinCondition
				:select3Val.sync="select3Val"
				:yueling1.sync="yueling1"
				:yueling2.sync="yueling2"
				:now_time.sync="now_time"
				:vip_name.sync="vip_name"
				:cabeza_name.sync="cabeza_name"
				:cabeza_tel.sync="cabeza_tel"
				:selectVal.sync="selectVal"
				:select_Val.sync="select_Val"
				:show_zj="show_zj"
				:options="options"
				:option2="option2"
				@doSearch="getData"
				@clear_search="clear_search"
				@doSearch_2="getData(1, 2)"
				@getStatus="getStatus"
			>
			</genjinCondition>
		</div>

	   <el-table
	    :data="tableData"
	    border
	    style="width: 100%"
	    :cell-style="getClass"
		@selection-change="handleSelectionChange">
		<el-table-column type="selection" width="40">
			</el-table-column>
			<el-table-column prop="gj_type" label="状态" width="100">
			</el-table-column>
			<el-table-column label="创建时间" width="100">
				<template slot-scope="scope">
					<span>{{ scope.row.create_time ? scope.row.create_time : '--' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="会员姓名" width="90">
				<template slot-scope="scope">
					<span style="cursor: pointer;" @click="pop(scope.row.user_id)">{{ scope.row.baobao_name ? scope.row.baobao_name : '--' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="家长姓名" width="90">
				<template slot-scope="scope">
					<span>{{ scope.row.p_name ? scope.row.p_name : '--' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="电话" width="110">
				<template slot-scope="scope">
					<span>{{ scope.row.p_phone ? scope.row.p_phone : '--' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="会员生日" width="100">
				<template slot-scope="scope">
					<span>{{ scope.row.baobao_birthday ? scope.row.baobao_birthday : '--' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="上次跟进" width="100">
				<template slot-scope="scope">
					<span>{{ scope.row.last ? scope.row.last : '--' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="来源" width="100">
				<template slot-scope="scope">
					<span>{{ scope.row.laiyuan ? scope.row.laiyuan : '--' }}</span>
				</template>
			</el-table-column>
			<el-table-column label="跟进记录">
				<template slot-scope="scope">
					<span style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;overflow: hidden;">{{ scope.row.neirong ? scope.row.neirong : '--' }}</span>
				</template>
			</el-table-column>
	  </el-table>

		<!--分页-->
		<div style="margin-top: 15px;">
		  <el-button size="mini" type="success" @click="move" style="float: left;margin-right: 15px;">转给他人</el-button>
		  <el-pagination
			  @size-change="handleSizeChange"
			  @current-change="handleCurrentChange"
			  :current-page="now_page"
			  :page-sizes="[10, 50]"
			  background
			  :page-size="pageSize"
			  layout="total, sizes, prev, pager, next"
			  prev-text="上一页"
			  next-text="下一页"
			  :total="totalNum">
		  </el-pagination>
		</div>

	   <!--转给他人-->
	   <el-dialog
		  title="提示"
		  :visible.sync="DialogVisible"
		  center
		  width="25%">
		  <span style="color: red;vertical-align: middle;">*</span>
		  <label>选择销售：</label>
		  <select name="" v-model="sell_name" style="width: 250px;height: 30px;padding-left: 8px;">
	    	 <option value="">请选择销售</option>
	    	 <option v-for="(item,index) in sellData" :value="item.user_id">
	    		{{ item.username }}
	    	 </option>
	      </select>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="DialogVisible = false" size="mini">取 消</el-button>
		    <el-button type="success" @click="confirm_move" size="mini">确 定</el-button>
		  </span>
	   </el-dialog>

	    <!--退回公海-->
	    <el-dialog
		  title="提示"
		  :visible.sync="send_state"
		  width="30%">
		  <span>确定删除此学员？</span>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="send_state = false">取 消</el-button>
		    <el-button type="success" @click="confirm_back">确 定</el-button>
		  </span>
		</el-dialog>

	  <!--潜客详细信息-->
	  <transition name="fade">
	    <div class="right-pop" v-show="popShow">
	  	  <div class="head">
	  	  	 <img src="/static/qmsj/img/genjin/boshi.png" class="head-img" />
	  	  	 <span class="name">{{popData.baobao_name ? popData.baobao_name : '--'}}</span>
	  	  	 <div class="right">
	  	  	 	<span class="move" @click="send_back">删除</span>
	  	  	 	<img src="/static/qmsj/img/genjin/Close.png" @click="close" class="close"/>
	  	  	 </div>

	  	  	 <div class="head_content">
	  	  	 	<span>最后跟进时间：{{popData.lasttime ? popData.lasttime : '--'}}</span>
	  	  	 	<span>下次跟进时间：{{popData.lastgjtime ? popData.lastgjtime : '--'}}</span>
	  	  	 	<span>负责销售：{{popData.gwname ? popData.gwname : '--'}}</span>
	  	  	 	<span>跟进状态：{{popData.gj_type ? popData.gj_type : '--'}}</span>
	  	  	 </div>
	  	  </div>

	      <!--tab切换-->
	  	  <el-tabs type="border-card">
			  <el-tab-pane label="详细信息">
			  	 <!-- 展示信息的组件 -->
                <genjinInfoBox :popData="popData"></genjinInfoBox>
			  </el-tab-pane>

			  <el-tab-pane label="跟进记录">
			  	  <textarea v-model="text_val" placeholder="新建跟进记录...(必填，限200字)" name="" rows="" cols=""></textarea>
			  	  <form class="down_form">
				  	 <select name="" v-model="way_val" style="width: 12%;height: 27px;float: left;">
				  	 	<option value="">跟进方式</option>
				  	 	<option v-for="item in way" :value="item.name">
				  	 		{{item.name}}
				  	 	</option>
				  	 </select>

				  	 <el-date-picker
				       value-format="yyyy-MM-dd"
				       v-model="make_time"
				       size="mini"
				       type="date"
				       placeholder="预约到访时间">
				     </el-date-picker>

				  	 <el-date-picker
				       value-format="yyyy-MM-dd"
				       v-model="last_time"
				       size="mini"
				       type="date"
				       placeholder="下次跟进时间">
				     </el-date-picker>

				  	 <select name="" v-model="follow_val" @change="update_gj_type" style="height: 27px;margin-left: 5px;">
				  	 	<option value="">跟进状态</option>
                        <option
							v-for="item in option1"
							:value="item.content"
							:key="item.content"
						>{{item.content}}</option>
				  	 </select>
				  	 <input type="button" class="issue" name="" id="" @click="issue" value="发布" />

				  	 <!--跟进记录-->
				  	 <div class="record-content" v-for="(item,index) in recordData" v-show="recordShow">
				  	 	 <div class="record">
					  	 	<span>跟进时间: {{item.create_time ? item.create_time : '--'}}</span>
					  	 	<span>预约时间: {{item.st_time ? item.st_time : '--'}}</span>
					  	 	<span>
					  	 		跟进方式: {{item.fangshi ? item.fangshi : '--'}}
					  	 		<button  :class="visit_state ? 'yet' : 'not'" v-text="visit_txt" @click="visit()" v-show="index == 0">未到访</button>
					  	 	</span>
					  	 </div>
				  	 	 <img src="/static/qmsj/img/genjin/header.png" class="header-img"/>
				  	 	 <span class="img-txt">{{item.username ? item.username : '--'}}</span>
				  	 	 <span class="right-txt" @click="del_record(item.gj_id)">删除</span>
				  	 	 <div class="content">{{item.neirong ? item.neirong : '--'}}</div>
				  	 </div>
				  </form>
			  </el-tab-pane>
		  </el-tabs>
	    </div>
	  </transition>

	  <!--删除跟进记录-->
	  <el-dialog
		  title="删除"
		  :visible.sync="del_dialogVisible"
		  center
		  width="25%">
		  <span>是否删除此条记录？</span>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="del_dialogVisible = false" size="mini">取 消</el-button>
		    <el-button type="success" @click="confirm_del" size="mini">确 定</el-button>
		  </span>
	  </el-dialog>

	</div>
</template>

<script>
	import genjinCondition from '../../components/genjinCondition'
    import genjinInfoBox from "../../components/genjinInfoBox";
	export default {
		components: { genjinCondition, genjinInfoBox },
	    data() {
	      return {
	        value2: '',
	        // 分页
            totalNum:0,
            now_page:1,
			isShow:false,
	        show_zj: 2,
			//表格
			yueling1:'',
			yueling2:'',
			now_time: '',
            vip_name:'',
            cabeza_name:'',
            cabeza_tel:'',
            selectVal: '',
            select_Val:'',
            select3Val:'',
            token:'',
            userid:'',
            popData:[],
            recordData:[],//跟进记录
            name_id:'',//会员姓名ID
            record_id:'',
            recordShow:false,
            sell_name:'',
            sellData:[],
            popShow:false,
            dialogVisible: false,
            DialogVisible: false,
            //到访按钮
            visit_txt:'未到访',
            option1:[
               {name:'新客户'},
               {name:'重点关注'},
               {name:'新分配'},
               {name:'已跟进'},
               {name:'持续跟进'},
               {name:'预约未到访'},
               {name:'已到访'},
               {name:'放弃'}
            ],
            relation:[
               {name:'爸爸',value:1},
               {name:'妈妈',value:2},
               {name:'爷爷',value:3},
               {name:'奶奶',value:4},
                {name:'姥爷',value:5},
                {name:'姥姥',value:6},
            ],
            option2:[
               {name:'市场'},
               {name:'walkin'},
               {name:'callin'},
               {name:'转介绍'},
               {name:'大众点评'},
               {name:'拉访'},
               {name:'网络'},
               {name:'校园'},
               {name:'其它'}
            ],
            way:[
               {name:'电话'},
               {name:'短信'},
               {name:'到店'}
            ],
            week:[
               {name:'星期一',value:1},
               {name:'星期二',value:2},
               {name:'星期三',value:3},
               {name:'星期四',value:4},
               {name:'星期五',value:5},
               {name:'星期六',value:6},
               {name:'星期日',value:7}
            ],
            follow_type:[
               {name:'重点关注'},
               {name:'已跟进'},
               {name:'持续跟进'},
               {name:'预约未到访'},
               {name:'已到访'},
               {name:'放弃'}
            ],
            courseData:[], //课程数据
            text_val:'', //跟进内容
            way_val:'',//跟进方式
            week_val:'',//跟进日期
            make_time:'',//预约时间
            last_time:'', //下次跟进时间
            follow_val:'',//跟进状态
            course_val:'', //选择课程
            visit_state:false,
            ids:'', //记录id
            options: [],
	        tableData: [],
	        tables:[],
	        //修改弹出框
	        radio:'男',
	        save_list:[],
	        save_list2:[],
	        del_dialogVisible: false, //删除记录
	        del_id:'',//删除记录ID
	        send_state:false, //退回公海
			pageSize: 10,
			multipleSelection: [],//多选框
			isSubmit: false
	      }
	    },
	    created(){
            let that = this
            that.token = that.$cookies.get('token');

			// 下拉框数据
            $.ajax({
				  url: process.env.apiUrl +'saas/nn/sales',
				  type: 'post',
				  data:{
				  	token:that.token
				  },
				  success: function (data, status) {
					  if(data.status == 1){
						  that.options=data.data
					  }else{
						  // that.$message.error({message:data.msg})
					  }

				  },
				  fail: function (err, status) {
				     console.log(err)
				 }
			})
            //请求表格数据
            that.getData();
			this.get_laiyuan()
			$.ajax({
				url: process.env.apiUrl +'saas/qk/is_zongjian',
				type: 'post',
				data: {
					token: that.token
				},
				success: function(res) {
					if (res.status == 1) {
						that.show_zj = res.show_zj
					} else {
						console.log(res.msg)
					}
				}
			})
	    },
	    methods:{
			// 从子组件传递回来的 跟进状态 数组
			getStatus(data) {
				this.option1 = data
			},
			// 来源下拉
			get_laiyuan(){
				let that = this
				$.ajax({
					url: process.env.apiUrl +'saas/index/get_source',
					type: 'post',
					data: {
						token: that.token
					},
					success: function(e) {
						that.option2 = e.data
					},
				})
			},
            //切换跟进状态
            update_gj_type(){
                let that = this
                $.ajax({
                    url: process.env.apiUrl +'saas/nn/update_gj_type',
                    type: 'post',
                    data: {
                        token: that.token,
                        user_id:that.record_id,
                        gj_type:that.follow_val
                    },
                    success: function(e) {

                    },
                })
            },
			//表格数据
			//表格数据
			getData(current_page,t) {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				if(!current_page){
					current_page=this.now_page
				}
				let that = this
				that.now_page = current_page
				let time_s = '', time_e = ''
				if(this.now_time){
					time_s = this.now_time[0]
					time_e = this.now_time[1]
				}
				$.ajax({
					url: process.env.apiUrl +'saas/nn/vip_follow',
					type: 'post',
					data: {
						time_s: time_s,
						time_e: time_e,
						name: that.vip_name,
						pname: that.cabeza_name,
						pphone: that.cabeza_tel,
						type: that.selectVal,
						salesperson: that.select_Val,
						laiy: that.select3Val,
						page: that.now_page,
						yueling1:that.yueling1,
						yueling2:that.yueling2,
						token: that.token,
						pageone: that.pageSize
					},
					success: function(data, status) {
						loading.close();
						if (data.status == 1) {
							that.tableData = data.data
							that.totalNum = data.map.count
							if(t && data.data != ''){ //删除所属顾问
								that.market_num = data.data[0].num
							}else{
								that.market_num = 0
							}
						} else {
							that.tableData = []
							that.totalNum = 0
						}
					},
					fail: function(err, status) {
						console.log(err)
					}
				})
			},
	    	//切换顾问
	    	market_save(){
	    		let that = this
	    		$.ajax({
					  url: process.env.apiUrl +'saas/nn/vip_follow',
					  type: 'post',
					  data:{
					  	  salesperson:that.select_Val,
					  	  token:that.token
					  },
					  success: function (data, status) {
					  	 that.tableData = data.data
					  	 if(data.status == 1){
					  	 	//总条数
					  	    that.totalNum = data.map.count
					  	 }else if(data.status == 2){
					  	 	 that.totalNum = 0
					  	 	 that.market_num = 0
					  	 }
					  },
					  fail: function (err, status) {
					     console.log(err)
					 }
				})
	    	},
	    	//搜索
            search(){
            	let that = this
            	$.ajax({
					  url: process.env.apiUrl +'saas/nn/vip_follow',
					  type: 'post',
					  data:{
					  	nianyue:that.now_time,
					  	name:that.vip_name,
					  	pname:that.cabeza_name,
					  	pphone:that.cabeza_tel,
					  	type:that.selectVal,
					  	salesperson:that.select_Val,
					  	laiy:that.select3val,
					  	page:that.now_page,
				  	    token:that.token
					  },
					  success: function (data, status) {
					     if(data.status == 1){
					  	 	that.tableData=data.data
					        that.totalNum = data.map.count
					  	 }else{
                             that.tableData=[]
                             that.totalNum = 0
					  	 }
					  },
					  fail: function (err, status) {
					     console.log(err)
					 }
				})
            },
            //姓名高亮
		    getClass({ row, column, rowIndex, columnIndex }) {
				if(columnIndex == 3){
				 	return 'color:rgb(98, 158, 241)'
				}
			},
			//右侧弹出框
			pop(id){
				document.documentElement.scrollTop = document.body.scrollTop = 0;
				this.popShow = true
				this.record_id = id

				let that = this
				$.ajax({
					  url: process.env.apiUrl +'saas/nn/details',
					  type: 'post',
					  data:{
					  	 userid:id,
					  	 token:that.token
					  },
					  success: function (data, status) {
					  	 that.popData=data.data
                          that.follow_val = data.data.gj_type;
					  },
					  fail: function (err, status) {
					     console.log(err)
					  }
				})
				//跟进记录数据
				that.get_record();
			},
			//跟进记录
			get_record(){
				 let that = this
				 $.ajax({
					  url: process.env.apiUrl +'saas/nn/follow',
					  type: 'post',
					  data:{
					  	 user_id:that.record_id,
					  	 token:that.token
					  },
					  success: function (data, status) {
					  	 that.recordData = data.data
					  	 if(data.status == 1){
					  	 	that.recordShow = true
					  		that.recordLength = data.data.length
					  	 }
					  },
					  fail: function (err, status) {
					     console.log(err)
					  }
				 })
			},
			// 删除跟进记录
            del_record(id){
            	let that = this
            	that.del_dialogVisible = true
            	$.ajax({
					  url: process.env.apiUrl +'saas/nn/del',
					  type: 'post',
					  data:{
					  	 gj_id:id,
					  	 token:that.token
					  },
					  success: function (data, status) {
					  	 console.log(data)
					  },
					  fail: function (err, status) {
					     console.log(err)
					  }
				 })
            },
            //确认删除记录
            confirm_del(){
            	this.del_dialogVisible = false

            	let that = this
				that.get_record();
			},
			//多选
			handleSelectionChange(val) {
				let arr = []
				for(let i in val){
					arr.push(val[i].user_id)
				}
				this.multipleSelection = arr
			},
			//转给他人
			move(){
				if(this.multipleSelection.length == 0){
					this.$message.error({message:'请先选择客户'})
				}else{
					this.DialogVisible = true
					let self = this
					//销售人员列表
					$.ajax({
						  url: process.env.apiUrl +'saas/qk/yxlb',
						  type: 'post',
						  data:{
							 token:self.token
						  },
						  success: function (data, status) {
							 self.sellData=data.data
						  },
						  fail: function (err, status) {
							 console.log(err)
						  }
					})
				}
            },
			// 确认
            confirm_move(){
				if(!this.sell_name){
					this.$message.error({message:'请先选择销售'})
				}else{
					this.DialogVisible = false

					let that = this
					$.ajax({
						  url: process.env.apiUrl +'saas/qk/zgtr',
						  type: 'post',
						  data:{
						  	 user_id:that.multipleSelection,
						  	 uid:that.sell_name,
						  	 token:that.token
						  },
						  success: function (data, status) {
						  	 if(data.status == 1){
						  	 	that.move_success();
								that.getData()
						  	 } else{
								 this.$message.error({message:data.msg})
							 }
						  },
						  fail: function (err, status) {
						     console.log(err)
						  }
					})
				}
            },
            move_success(){
            	this.$message({
		          message: '分配成功',
		          type: 'success'
		        });
            },
            //根据日期选择课程
            week_save(){
            	let self = this
            	$.ajax({
					  url: process.env.apiUrl +'saas/qk/xzkc',
					  type: 'post',
					  data:{
					  	 week:self.week_val,
					  	 token:self.token
					  },
					  success: function (data, status) {
					  	  self.courseData=data.data
					  },
					  fail: function (err, status) {
					     console.log(err)
					  }
				})
            },
            //发布
			issue(){
				if (this.isSubmit) {
					return
				}
				this.isSubmit = true
				let self = this
				$.ajax({
					  url: process.env.apiUrl +'saas/nn/addfollow',
					  type: 'post',
					  data:{
					  	 bao_id:self.record_id,
					  	 neirong:self.text_val,
					  	 fangshi:self.way_val,
					  	 st_time:self.make_time,
					  	 lasttime:self.last_time,
					  	 zhuangtai:self.follow_val,
					  	 token:self.token
					  },
					  success: function (data, status) {
					  	 if(self.text_val == ''){
					  	 	alert('请输入跟进内容')
					  	 	return false;
					  	 }
					  	 if(data.status == 1){
							self.getData()
					  	 	self.$message.success('添加成功');
					  	 	//添加跟进记录
					  	    self.get_record();
					  	    //清空已添加的跟进内容
					  	    self.text_val=''; //文本域
				            self.way_val='';//跟进方式
				            self.week_val='';//跟进日期
				            self.make_time='';//预约时间
				            self.last_time=''; //下次跟进时间
				            self.follow_val='';//跟进状态
					  	 }
					  },
					  fail: function (err, status) {
					     console.log(err)
					  },
						complete: function() {
							self.isSubmit = false
						}
				 })
			},
            //到访按钮
            visit(id1){
            	this.visit_state = !this.visit_state
            	if(this.visit_state == false){
            		this.visit_txt = '未到访'
            	}else{
            		this.visit_txt = '已到访'
            	}

            	$.ajax({
					  url: process.env.apiUrl +'saas/qk/dfqh',
					  type: 'post',
					  data:{
					  	 id:id1,
					  	 token:this.token
					  },
					  success: function (data, status) {
					  	 console.log(data)
					  },
					  fail: function (err, status) {
					     console.log(err)
					  }
				})

            },
//          关闭右侧弹出框
			close(){
				this.popShow = false
			},
			//退回公海
			send_back(){
		        this.send_state = true
		    },
		    confirm_back(){
		    	this.send_state = false

		    	let that = this
		        $.ajax({
				  url: process.env.apiUrl +'saas/qk/tuihui',
				  type: 'post',
				  data:{
				  	user_id:that.record_id,
				  	token:that.token
				  },
				  success: function (data, status) {
				  	  if(data.status == 1){
				  	  	 //刷新视图
            		 	 that.getData();
            		 	 that.send_success();
				  	  }
				  },
				  fail: function (err, status) {
				     console.log(err)
				  }
			    })
		    },
		    send_success(){
		    	this.$message({
		          message: '已退回公海',
		          type: 'success'
		        });
		    },
			//分页
			handleSizeChange(val) {
			    this.pageSize = val
				this.getData()
			},
			handleCurrentChange(val) {
				this.now_page=val
				this.getData()
			},
		    //清空搜索条件
			clear_search() {
				this.vip_name = '';
				this.cabeza_name = '';
				this.cabeza_tel = '';
				this.selectVal = '';
				this.select_Val = '';
				this.select3Val = '';
				this.now_time = '';
				this.yueling1 = '';
				this.yueling2 = '';
				this.getData()
			},
	     }
	  };
</script>

<style lang="less" scoped="scoped">
     /*修改弹出框*/
     .el-dialog{
     	.save-input{
     		height: 26px;
		    line-height: 26px;
		    border-radius: 2px;
		    border: 1px solid gainsboro;
		    padding-left: 5px;
     	}
     	.el-date-editor.el-input, .el-date-editor.el-input__inner {
		    width: 160px;
		    margin-top: 10px;
		}
		.line{
			margin-top: 10px;
			.add{
				width: 20px;
				vertical-align: middle;
				text-align: center;
				font-weight: bolder;
				display: inline-block;
				background: #79C4C7;
				border-radius: 50%;
				color: white;
				font-size: 15px;
				cursor: pointer;
			}
		}
     }
     /*确认删除*/
     .header .el-button--default{
     	color: white;
     }
     .header .block .el-date-editor.el-input[data-v-82287e62], .header .block .el-date-editor.el-input__inner[data-v-82287e62] {
	    width: 140px;
	 }
     #app{
     	padding: 10px;
     	position: relative;
     }
     .right-pop{
	    width: 800px;
	    display: inline-block;
	    position: absolute;
     	background: white;
     	border: 1px solid gainsboro;
     	display: inline-block;
     	position: absolute;
     	top: 0;
     	right: 0;
     	z-index: 99;
     	.head{
     		padding: 10px;
     		.head-img{
     			width: 35px;
     			float: left;
     		}
     		.name{
     			margin-top: 9px;
			    margin-left: 8px;
			    display: inline-block;
     		}
     		.right{
     			float: right;
     			margin-top: 5px;
     			.move{
     				display: inline-block;
				    float: left;
				    width: 85px;
				    text-align: center;
				    padding: 5px 0;
				    border: 1px solid #adadad;
				    border-radius: 2px;
				    margin-right: 2px;
				    cursor: pointer;
     			}
     			.el-button--text{
     				float: left;
				    width: 85px;
				    text-align: center;
				    padding: 7px 0;
				    border: 1px solid #adadad;
				    border-radius: 2px;
				    color: black;
     			}
     			.close{
     				margin-top: 5px;
				    margin-left: 7px;
				    margin-right: 5px;
				    width: 20px;
     			}
     		}
     		.head_content {
     			margin-bottom: 7px;
     			clear: both;
     			span{
	     			display: inline-block;
	     			margin-left: 30px;
	     			padding-top: 12px;
	     		}
     		}
     	}
     	.el-tabs--border-card{
     		box-shadow: none;
     	}
     	textarea{
     		width: 100%;
     		height: 63px;
     	}
     	.fade-enter-active, .fade-leave-active {
	       transition: opacity 1s;
		}
		.fade-enter, .fade-leave-to {
		    opacity: 0;
		}
     	.el-tabs--border-card{
     		border-left: 0;
     		border-bottom: 0;
     	}
     	.down_form{
     		margin-top: 15px;
     		padding-bottom: 20px;
     		.el-date-editor.el-input, .el-date-editor.el-input__inner{
     			width: 135px;
     			margin-left: 5px;
     			float: left;
     		}
     		.issue{
     			 padding: 3px 11px;
     			 color: #fff;
                 background-color: #8CBB77;
                 border:1px solid #8CBB77;
                 border-radius: 2px;
     		}
     		.record-content{
     			margin-bottom: 10px;
     			.record{
	     			height: 40px;
	     			line-height: 40px;
	     			margin-bottom: 10px;
	     			margin-top: 20px;
	     			padding-left: 20px;
	     			background-color: rgb(241, 241, 241);
	     			color: rgb(102, 102, 102);
	     			span{
	     				display: inline-block;
	     				padding-right: 50px;
	     			}
	     			.yet{
	     				padding: 3px 6px;
	     				background-color: #449d44;
						border: 0;
	     				border-radius: 10px;
	     				color: white;
	     				margin-left: 10px;
	     				font-size: 14px;
	     				cursor: pointer;
	     				outline: none;
	     			}
	     			.not{
	     				padding: 3px 6px;
	     				background-color: #f0ad4e;
						border: 0;
	     				border-radius: 10px;
	     				color: white;
	     				margin-left: 10px;
	     				font-size: 14px;
	     				cursor: pointer;
	     				outline: none;
	     			}
	     		}
	     		.header-img{
	     			float: left;
	     			margin: 0 15px;
	     			width: 50px;
	     		}
	     		.img-txt{
	     			display: inline-block;
	     			padding: 2px 5px;
   				    border-radius: 10px;
   				    color: #fff;
				    background-color: #8CBB77;
				    border-color: #2e6da4;
				    font-size: 14px;
				    font-weight: bold;
				    margin-top: 18px;
	     		}
	     		.right-txt{
	     			float: right;
	     			padding-top: 18px;
	     			padding-right: 30px;
    				color: rgb(93, 156, 236);
    				display: inline-block;
	     		}
	     		.content{
	     			padding-left: 84px;
    				height: 50px;
    				clear: both;
	     		}
     		}

     	}

     }
     .header{
     	  margin-bottom: 15px;
     	 .block{
     		display: inline-block;
     		.el-date-editor.el-input, .el-date-editor.el-input__inner {
			    width: 131px;
			}
     	 }
     	 .name{
     	 	display: inline-block;
		    height: 36px;
		    padding-left: 16px;
		    margin-left: 5px;
		    font-size: 14px;
		    line-height: 1.42857143;
		    color: #555;
		    background-color: #fff;
		    border: 1px solid #ccc;
		    border-radius: 4px;
     	 }
     	 .el-button{
     	 	padding: 6px 14px;
     	 	background-color: #8CBB77;
     	 	margin-left: 15px;
     	 	margin-right: 6px;
     	 	vertical-align: middle;
     	 }
     	 .refresh-btn{
     	 	width: 43px;
     	 	border: 1px solid #E4E7ED;
            line-height: 24px;
     	 	background-color: white;
     	 	border-radius: 2px;
     	 	cursor: pointer;
     	 	vertical-align: middle;
     	 }
     	 .delete{
     	 	width: 110px;
     	 	color: #fff;
     	 	border: 0;
            background-color: #8CBB77;
            display: inline-block;
		    padding: 8px 12px;
		    margin-bottom: 0;
		    font-size: 14px;
		    font-weight: 400;
		    line-height: 1.42857143;
		    text-align: center;
		    border-radius: 3px;
		    cursor: pointer;
		    margin-left: 5px;
     	 }
     }

</style>



// WEBPACK FOOTER //
// src/pages/genjin/Vjinrigj.vue